import { Outlet } from 'react-router-dom';
import { Sidebar } from './sidebar';
import { useEmbedMode, useLocalStorage } from '@/hooks';
import { config } from '@/config';

export function MainLayout() {
  const isEmbedded = useEmbedMode();
  const [sidebarCollapsed, setSidebarCollapsed] = useLocalStorage(
    'telviaiq-sidebar-collapsed',
    false
  );

  // In embed mode, render without sidebar
  if (isEmbedded) {
    return (
      <div className="min-h-screen bg-surface-page">
        <main className="p-4">
          <Outlet />
        </main>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-surface-page flex">
      {/* Sidebar */}
      <Sidebar collapsed={sidebarCollapsed} onCollapsedChange={setSidebarCollapsed} />

      {/* Main content area */}
      <div className="flex-1 flex flex-col min-h-screen">
        {/* Page content - PageHeader is rendered by each page */}
        <main className="flex-1">
          <Outlet />
        </main>

        {/* Footer */}
        <footer className="bg-white border-t border-slate-200 py-4 px-6">
          <div className="text-center text-sm text-slate-500">
            © {new Date().getFullYear()} {config.appName} ·{' '}
            <a
              href={`mailto:${config.supportEmail}`}
              className="text-indigo-600 hover:underline"
            >
              {config.supportEmail}
            </a>
            {' · '}
            <a
              href={`tel:${config.supportPhone}`}
              className="text-indigo-600 hover:underline"
            >
              {config.supportPhone}
            </a>
          </div>
        </footer>
      </div>
    </div>
  );
}
